export function getNumericAspectRatio(aspectRatio) {
    return NumericAspectRatio[aspectRatio];
}
export const NumericAspectRatio = {
    '16:9': 16 / 9,
    '9:16': 9 / 16,
    '4:3': 4 / 3,
    '3:4': 3 / 4,
    '1:1': 1,
    '10:6': 10 / 6,
    '6:5': 6 / 5,
    '2:1': 2,
    '1:2': 1 / 2,
    '2:3': 2 / 3,
    '4:5': 4 / 5,
    '3:2': 3 / 2
};
